import { render } from "./AccountRegister.vue?vue&type=template&id=7fbb8cc4"
import script from "./AccountRegister.vue?vue&type=script&lang=js"
export * from "./AccountRegister.vue?vue&type=script&lang=js"

import "./AccountRegister.vue?vue&type=style&index=0&id=7fbb8cc4&lang=css"
script.render = render

export default script